import { RequestUserConfig } from '../common/types'
import { NetworkService } from '../services'
import { BaseTransport } from '../transports'
import ListingSectionTransport from '../transports/common/listing-section-transport'

export interface PartnerSearchParamsTransport {
    srlUri: string
    pageNumber?: number
    pageSize?: number
}

class PartnerClient {
    public searchHolidu({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: PartnerSearchParamsTransport
    }): Promise<BaseTransport<ListingSectionTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': 'traum-ferienwohnungen.de',
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            url: '/api/search/v1/external-partner/holidu/search',
            headers,
            params,
        })
    }
}

export default new PartnerClient()
